import type { IconProps } from './IconProps';

export const UnknownBadgeIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width={props.width ?? 32}
    height={props.height ?? 32}
    {...props}
  >
    <g filter="url(#filter0_i_2188_21977)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.619 1.45075C15.8719 1.4142 16.1288 1.4142 16.3817 1.45075C16.6732 1.49288 16.9445 1.59535 17.1599 1.67671L17.2176 1.69847L24.5408 4.44449C25.3646 4.75203 26.0879 5.0221 26.645 5.51307C27.1324 5.94256 27.5078 6.48429 27.7388 7.09141C28.0029 7.78542 28.0018 8.55758 28.0005 9.43684L28.0004 15.9993C28.0004 19.7682 25.9506 22.9103 23.7349 25.2186C21.5044 27.5423 18.9524 29.1836 17.6029 29.9708L17.5482 30.0029C17.302 30.1475 16.9823 30.3352 16.5595 30.4259C16.2136 30.5 15.7871 30.5 15.4412 30.4259C15.0184 30.3352 14.6987 30.1475 14.4525 30.0029L14.3978 29.9708C13.0483 29.1836 10.4963 27.5423 8.26577 25.2186C6.05008 22.9103 4.00035 19.7682 4.00035 15.9993L4.00017 9.43685C3.9989 8.55759 3.99778 7.78543 4.26187 7.09141C4.4929 6.48429 4.86832 5.94256 5.35567 5.51307C5.91277 5.0221 6.63615 4.75203 7.45988 4.44449L14.7831 1.69847L14.8408 1.67672C15.0562 1.59535 15.3275 1.49288 15.619 1.45075Z"
        fill="url(#paint0_linear_2188_21977)"
      />
    </g>
    <g filter="url(#filter1_i_2188_21977)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3183 12.2316C15.6571 12.0324 16.0556 11.9596 16.443 12.0261C16.8304 12.0925 17.1818 12.294 17.4349 12.5947C17.6881 12.8954 17.8266 13.276 17.826 13.669L17.826 13.671C17.826 13.9625 17.5898 14.364 16.9209 14.8099C16.627 15.0059 16.3236 15.1585 16.0885 15.263C15.9728 15.3144 15.8782 15.3521 15.8157 15.376C15.7846 15.3878 15.7617 15.3961 15.7486 15.4008L15.7367 15.405C15.0404 15.6392 14.6642 16.393 14.8967 17.0904C15.1295 17.789 15.8846 18.1666 16.5832 17.9337L16.7651 17.8679C16.8665 17.8293 17.0061 17.7733 17.1715 17.6998C17.4984 17.5545 17.9445 17.3325 18.4001 17.0287C19.2299 16.4755 20.4924 15.3783 20.4927 13.6716C20.4939 12.6493 20.1334 11.6595 19.475 10.8773C18.8163 10.0948 17.9019 9.57072 16.8938 9.3978C15.8857 9.22488 14.8489 9.41433 13.9671 9.93258C13.0853 10.4508 12.4153 11.2644 12.0759 12.2293C11.8316 12.924 12.1966 13.6852 12.8912 13.9295C13.5859 14.1739 14.3471 13.8089 14.5915 13.1142C14.7219 12.7434 14.9794 12.4308 15.3183 12.2316ZM16.2002 19.3354C15.4638 19.3354 14.8669 19.9324 14.8669 20.6688C14.8669 21.4052 15.4638 22.0021 16.2002 22.0021H16.2135C16.9499 22.0021 17.5469 21.4052 17.5469 20.6688C17.5469 19.9324 16.9499 19.3354 16.2135 19.3354H16.2002Z"
        fill="url(#paint1_linear_2188_21977)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_2188_21977"
        x="4"
        y="1.42334"
        width="24.0005"
        height="29.0581"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2188_21977" />
      </filter>
      <filter
        id="filter1_i_2188_21977"
        x="12"
        y="9.33545"
        width="8.49268"
        height="12.6665"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2188_21977" />
      </filter>
      <linearGradient
        id="paint0_linear_2188_21977"
        x1="34.0009"
        y1="30.4815"
        x2="-4.11929"
        y2="5.45455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B7B7B7" />
        <stop offset="1" stopColor="#C8C8C8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2188_21977"
        x1="20.59"
        y1="7.33752"
        x2="11.0194"
        y2="19.8756"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.67" />
      </linearGradient>
    </defs>
  </svg>
);
